import type { ComponentProps } from 'react'
import React from 'react'
import CaptionTextBlock from '../TextBlocks/CaptionTextBlock'
import { useIntl } from 'react-intl'

type InheritedCaptionTextBlockProps = Pick<ComponentProps<typeof CaptionTextBlock>, 'endIcon'>

interface Props extends InheritedCaptionTextBlockProps {
}

function PriceRowTaxesAndFees(props: Props) {
  const { endIcon } = props
  const intl = useIntl()

  return <CaptionTextBlock
    variant="medium"
    weight="normal"
    colour="neutral-three"
    endIcon={endIcon}
  >
    {intl.formatMessage({
      id: 'H29/x+SS95',
      defaultMessage: 'Includes taxes & fees',
      description: 'Label indicating that taxes and fees are included in the price',
    })}
  </CaptionTextBlock>
}

export default PriceRowTaxesAndFees
